import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-attsession',
  templateUrl: './attsession.component.html',
  styleUrls: ['./attsession.component.scss'],
  providers:[MasterService,AttendanceService]
})
export class AttsessionComponent implements OnInit {
  sections:any=[];
  classes:any=[];
  fmodel:any={};
  smodel:any={};
  attdata:any=[];
  arrcourse:any=[];
  attsessdata:any=[];
  oprtype:any='';
  tabledata: any = {};
  strattmarked="";
  showload:any="no";
  showsms:any="no";
  cmodel:any={};
  attcordetdata:any=[];
  attcordata:any=[];
  objvhead:any={};
  corclasses:any=[];
    corsections:any=[];
  modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
  constructor(private http: HttpClient,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

  ngOnInit(): void {
    this.mascourse();
    //this.massection();
    this.fmodel.attdt=this.mservice.getdatetoday();
    this.smodel.frdt=this.mservice.getdatetoday();
    this.smodel.todt=this.mservice.getdatetoday();
    this.cmodel.frdt=this.mservice.getdatetoday();
    this.cmodel.todt=this.mservice.getdatetoday();
  }


  // masclass() {
  //   this.mservice.masclass()
  //       .subscribe(
  //       resultArray => {
  //           console.log('getdashcounts', resultArray);
  //           this.classes = resultArray;
  //           this.fmodel.clid=resultArray[0].clid;
  //          this.massection();
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }

  masclass() {
    this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'atclass')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.fmodel.clid=resultArray[0].clid;
            this.smodel.clid=resultArray[0].clid;
            //this.fmodel1.clid=resultArray[0].clid;
            this.massection();
          //  this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }
  corclass() {
    this.mservice.classmasterrolewise(0,this.cmodel.crid,0,'atclass')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.corclasses = resultArray;
            
            this.cmodel.clid=resultArray[0].clid;
            this.corsection();
           // this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }

  corsection() {
    this.mservice.sectionsrolewise(0,this.cmodel.crid,this.cmodel.clid,'atsection')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.corsections = resultArray;
            
            this.cmodel.scid=resultArray[0].scid;
            //this.corsubject(this.cmodel.clid,this.cmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }
  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrcourse = resultArray;
            this.fmodel.crid=resultArray[0].crid;
            this.cmodel.crid=resultArray[0].crid;
            this.smodel.crid=resultArray[0].crid;
            this.masclass();

            this.corclass();
            //this.fmodel1.crid=resultArray[0].crid;
        },
        error => console.log("Error :: " + error)
        )
  }

  // massection() {
  //   this.mservice.massection()
  //       .subscribe(
  //       resultArray => {
  //           console.log('getdashcounts', resultArray);
  //           this.sections = resultArray;
  //           this.fmodel.secid=resultArray[0].scid;
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }

  massection() {
    this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'atsection')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.secid=resultArray[0].scid;
            this.smodel.scid=resultArray[0].scid;
            this.SelectAttdDetails();
            // this.fmodel1.scid=resultArray[0].scid;
            // this.subjects(this.fmodel.clid,this.fmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }
  

  exportatsumsubrpt()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expattsumsess.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.smodel.frdt+"&dtto="+this.smodel.todt+"&clid="+this.smodel.clid+"&scid="+this.smodel.scid+"&crid="+this.smodel.crid;
   console.log("url",url)
   window.open(url,'');

}
  attsubsum() {
    //this.cmodel.oprtype='sum_subwise';
    console.log('pstdat',this.smodel);

    this.aservice.attsumsess(this.smodel)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.attsessdata = resultArray;
//this.colums=Object.keys(resultArray[0]);
        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }

  SelectAttdDetails() {
    debugger
    var clid = this.fmodel.clid;
    var crid = this.fmodel.crid;
    var secid = this.fmodel.secid;
    var attdt = this.fmodel.attdt;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selattses',clcd:clcd,aycd:aycd,crid:crid };
    console.log('model-by', asgnmtdata);
    this.aservice.by_sp_clmattendance(asgnmtdata)
        .subscribe(resultArray => {
            console.log('ret-by-atd', resultArray);
//alert(resultArray.length);
            if (resultArray.length>0)
            {
              this.showsms='yes';
this.strattmarked="Attendence already marked for the selected date";
               // alert('1');
            this.attdata = resultArray;
            this.oprtype="updattses";
            }

            else{
              this.showsms='no';
              //  alert('2');
              this.strattmarked="";
                this.SelectAttdDtlsifnotavail();
                this.oprtype="insattses";
            }
            //alert(resultArray.message);

        }, error =>
            alert('error in connection')
        );
}

// Savedetails()
// {

//   console.log('savearr',this.attdata);
// }

deleteattend(atid) {
  debugger
 // console.log('testdata', this.dataSource.data);
  if(confirm("Are you sure you wan't to delete ?"))
  {
 var pst={atid:atid};
  this.aservice.deleteattendance(pst)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);

          alert(resultArray.message);
          this.SelectAttdcorDetails();
      }, error =>
          alert('error in connection')
      );
    }
}
Savecordetails() {
  debugger
 // console.log('testdata', this.dataSource.data);
  // this.tabledata.loopdata = this.attdata;
  this.tabledata.dbnm = '';
  this.tabledata.oprtag="updattses";
  this.tabledata.attdt = this.objvhead.attdt;
  this.tabledata.clid = this.cmodel.clid;
  this.tabledata.crid = this.cmodel.crid;
  this.tabledata.secid = this.cmodel.scid;

  this.tabledata.clcd=localStorage.getItem('clcd');
  this.tabledata.aycd=localStorage.getItem('aycd');
 // this.tabledata.attdt = this.model.attdt;
  //this.tabledata.loopdata.attdt=this.model.attdt;
 // console.log('class-sec',this.model.clid+','+this.model.secid);
 // console.log("dbnm--dd",this.tabledata.loopdata);

  
  var arrattendance=this.attcordetdata.map(item => {
    if (item.s1 == false){
       item.s1=0;
     }
     else{
      item.s1=1;
     }

     if (item.s2 == false){
      item.s2=0;
    }
    else{
     item.s2=1;
    }
    
    return item;
   });

  
   this.tabledata.loopdata = arrattendance;
   console.log('attendance-data', this.tabledata);
  this.aservice.loop_clmattendance(this.tabledata)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);

          alert(resultArray.message);
         // this.SelectAttdDetails();
      }, error =>
          alert('error in connection')
      );
}

Savedetails() {
  debugger
 // console.log('testdata', this.dataSource.data);
  // this.tabledata.loopdata = this.attdata;
  this.tabledata.dbnm = '';
  this.tabledata.oprtag=this.oprtype;
  this.tabledata.attdt = this.fmodel.attdt;
  this.tabledata.clid = this.fmodel.clid;
  this.tabledata.crid = this.fmodel.crid;
  this.tabledata.secid = this.fmodel.secid;

  this.tabledata.clcd=localStorage.getItem('clcd');
  this.tabledata.aycd=localStorage.getItem('aycd');
 // this.tabledata.attdt = this.model.attdt;
  //this.tabledata.loopdata.attdt=this.model.attdt;
 // console.log('class-sec',this.model.clid+','+this.model.secid);
 // console.log("dbnm--dd",this.tabledata.loopdata);

  
  var arrattendance=this.attdata.map(item => {
    if (item.s1 == false){
       item.s1=0;
     }
     else{
      item.s1=1;
     }

     if (item.s2 == false){
      item.s2=0;
    }
    else{
     item.s2=1;
    }
    
    return item;
   });

  
   this.tabledata.loopdata = arrattendance;
   console.log('attendance-data', this.tabledata);
  this.aservice.loop_clmattendance(this.tabledata)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);

          alert(resultArray.message);
          this.SelectAttdDetails();
      }, error =>
          alert('error in connection')
      );
}

sendmarks()
  {
   this.showload="yes";
    var stulst=this.attdata.filter(item => item.s1===false);

   var stulst1= stulst.map(item => {
      
      
      
      return item.stuid;
     });
   // console.log('assid1',this.arrevpatern);
    console.log('assid2',stulst);
   // console.log('assid',this.asmtid);
    var postdata={atdt:this.fmodel.attdt,stulst:stulst1,tag:'comp'};
    console.log('postdata',postdata);
    this.aservice.sendsms(postdata)
    .subscribe(
    resultArray => {
        console.log('stulst', resultArray);
        alert(resultArray.message);
       this.showload="no";
        
       
    },
    error =>{ console.log("Error :: " + JSON.stringify(error));
    alert("Error in sending sms");
    this.showload="no";
  }
    )
  }

  getattdetails() {

    console.log('pstdat',this.objvhead);

    this.aservice.getattdet(this.objvhead)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.attcordetdata = resultArray;

        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }

  
  openmdldetmain(content,objdata) {
    debugger
      this.objvhead=objdata;
    
      this.getattdetails();
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
    
  onclickcorrection()
  {

    this.cmodel.frdt=this.aservice.getdatetoday();
    this.cmodel.todt=this.aservice.getdatetoday();
    this.mascourse();
  }


  SelectAttdcorDetails() {

    console.log('pstdat',this.cmodel);

    this.aservice.getattsumses(this.cmodel)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.attcordata = resultArray;

        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }


SelectAttdDtlsifnotavail() {
    debugger
    var clid = this.fmodel.clid;
    var crid = this.fmodel.crid;
    var secid = this.fmodel.secid;
    var attdt = this.fmodel.attdt;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selstuses',clcd:clcd,aycd:aycd,crid:crid};
    console.log('model-by', asgnmtdata);
    this.aservice.by_sp_clmattendance(asgnmtdata)
        .subscribe(resultArray => {
            console.log('ret-by-atd', resultArray);
            this.attdata = resultArray;

            //alert(resultArray.message);

        }, error =>
            alert('error in connection')
        );
}

}
